import { Actions } from '../../interfaces'
import { NegotiationResponse } from '@/entities/purchase'

import create from './create'
import fetch from './fetch'
import update from './update'
import find from './find'

export const actions: Actions = {
  create,
  fetch,
  update,
  find,
}

export default {
  Model: { NegotiationResponse },
  actions: { [NegotiationResponse.name]: actions },
}
